const appName = 'Kitsugi';
const gDrive = 'Диск';

export default {
    admin_info: 'Інформація',
    admin_total_users: 'Всього користувачів',
    admin_total_sessions: 'Всього сесій',
    admin_total_clients: 'Всього клієнтів',
    admin_users: 'Список користувачів',
    admin_sessions: 'Сесії',
    admin_logs: 'Логи',
    admin_create_user: 'Створити користувача',
    admin_create: 'Створити',
    admin_fill_required: 'Заповніть обов\'язкові поля',
    admin_fill_all_fields: 'Необхідно заповнити всі поля: Email, Пароль та Ім\'я',

    admin_user_logs: 'Логи користувача',
    admin_no_logs: 'Логи відсутні',
    admin_all_sessions: 'Всі сесії',
    admin_clients: 'Клієнти',
    admin_user_clients: 'Клієнти користувача',
    admin_client_name: 'Ім\'я',

    admin_create_error: 'Помилка при створенні користувача',
    admin_create_success: 'Користувача створено успішно',
    admin_invalid_email: 'Будь ласка, введіть коректний email',
    admin_password_too_short: 'Пароль повинен містити мінімум 6 символів',
    admin_tab_info: 'Інформація',
    admin_tab_users: 'Список користувачів',
    admin_tab_create: 'Створити',
    admin_tab_reports: 'Звіти',
    
    // Desktop and navigation
    desktop_title: 'Робочий стіл',
    
    // Admin panel translations
    'admin_loading_reports': 'Завантаження звітів...',
    'admin_reports_count': 'Звіти',
    'admin_no_reports': 'Звіти не знайдено',
    'admin_report_open': 'Відкрити',
    'admin_report_delete': 'Видалити',
    'admin_all_time': 'Весь час',
    'admin_last_week': 'Останній тиждень',
    'admin_last_month': 'Останній місяць',
    'admin_last_year': 'Останній рік',
    'admin_dataset_all': 'Все',
    'admin_dataset_users': 'Користувачі',
    'admin_dataset_sessions': 'Сесії',
    'admin_dataset_clients': 'Клієнти',
    'admin_loading_sessions': 'Завантаження сесій...',
    'admin_no_sessions': 'Немає доступних сесій',
    'admin_show_json': 'Показати JSON',
    'admin_hide_json': 'Сховати JSON',
    'admin_loading_clients': 'Завантаження клієнтів...',
    'admin_no_clients': 'Немає доступних клієнтів',
    'admin_client_sessions': 'Сесії клієнта',
    'admin_no_client_sessions': 'Немає доступних сесій для цього клієнта.',
    'admin_session_id': 'ID',
    'admin_prediction_id': 'ID передбачення',
    'admin_date': 'Дата',
    'admin_client_id': 'ID клієнта',
    'admin_title': 'Назва',
    'admin_status': 'Статус',
    'admin_date_to': 'Дата до',
    admin_email: "Email",
    admin_password: "Пароль",
    admin_first_name: "Ім'я",
    admin_last_name: "Прізвище",
    admin_disable_user: "Вимкнути",
    admin_enable_user: "Увімкнути",

    common_firstName: "Ім'я",
    common_lastName: "Прізвище", 
    common_save: "Зберегти",
    common_saving: "Збереження...",
    common_delete: "Видалити",
    common_reset: "Скинути",
    common_create: "Створити",

    sideMenu_profile: "Мій профіль",
    sideMenu_privacy: "Конфіденційність і безпека",
    sideMenu_language: "Мова",
    sideMenu_quickstart: "Швидкий старт",
    quickstart_content_welcome: "🚀 Швидкий старт: почніть працювати з клієнтами та аналізами",
    quickstart_content_descr: "Ця коротка інструкція допоможе вам зробити перші кроки та максимально використати можливості сервісу.",
    quickstart_content_1: "Створіть свого першого клієнта",
    quickstart_content_1_text:`Переключіть бічне меню на розділ «Клієнти» — кнопка знаходиться в лівому нижньому куті екрана, зліва від вашого аватара. Іконка — група людей.

Відкриється меню зі списком клієнтів. Поки тут порожньо, але скоро з'явиться список усіх ваших клієнтів.

Щоб додати клієнта, натисніть кнопку «плюс» праворуч від пошукового рядка вгорі меню.
Заповніть необхідні поля та натисніть «Створити».`,
    quickstart_content_2: "Почніть роботу з клієнтом",
    quickstart_content_2_text:`Клікніть по клієнту в списку.
Праворуч відкриється меню з чотирма вкладками:

Сесії — список усіх запланованих і проведених зустрічей.

Календар — ваш планувальник: можна створювати нові сесії або додавати інші події та завдання.

Життєві події — тут будуть збиратися події, які клієнт згадував під час сесій.

Аналіз — детальна аналітика по клієнту на основі всіх проведених сесій.`,
    quickstart_content_3: "Створіть першу сесію",
    quickstart_content_3_text:`Перейдіть у вкладку «Сесії».

Внизу праворуч натисніть кнопку з плюсиком — відкриється меню створення сесії.

Можна вказати повторення сесії — так ви одразу створите серію пов'язаних зустрічей для зручного редагування в майбутньому.`,
    quickstart_content_4:"Завантажте запис і отримайте аналіз",
    quickstart_content_4_text:`
Після створення сесія з'явиться в списку сесій.

У правій частині елемента сесії буде кнопка «Завантажити» — використовуйте її, щоб прикріпити відео або аудіозапис.

Після завантаження запису системі знадобиться трохи часу для аналізу.
Коли аналіз буде готовий, замість кнопки «Завантажити» з'явиться кнопка «Дивитися» — натисніть її, щоб побачити детальний розбір сесії.`,
    quickstart_done: "🎉 Готово!",
    quickstart_done_descr: `
Тепер ви знаєте, з чого почати.
Створюйте клієнтів, плануйте сесії та отримуйте цінний аналіз — ваш помічник завжди під рукою!`,
    sideMenu_faq: "FAQ",

    faq_general_title: "Загальні питання",
    faq_general_q1: "Що це за сервіс і чим він може допомогти мені як психологу?",
    faq_general_a1: "Наш сервіс допомагає психологам і психотерапевтам вести список клієнтів, планувати сесії, зберігати записи зустрічей і автоматично аналізувати їх зміст — щоб ви могли краще відстежувати прогрес і динаміку.",
    faq_general_q2: "Чи потрібно встановлювати якийсь додаток?",
    faq_general_a2: "Ні! Ви працюєте через браузер на будь-якому пристрої — всі ваші дані зберігаються в захищеній хмарі.",

    faq_clients_title: "Клієнти та профілі",
    faq_clients_q1: "Як додати нового клієнта?",
    faq_clients_a1: "Перейдіть у розділ «Клієнти», натисніть на значок «плюс» у верхній частині меню та заповніть необхідні дані.",
    faq_clients_q2: "Чи можна редагувати дані клієнта?",
    faq_clients_a2: "Так! Просто виберіть клієнта зі списку та відредагуйте потрібні поля. Усі зміни зберігаються автоматично.",

    faq_sessions_title: "Сесії та записи",
    faq_sessions_q1: "Як створити сесію?",
    faq_sessions_a1: "Зайдіть у вкладку «Сесії» у вибраного клієнта та натисніть кнопку «плюс» — ви можете вказати дату, час, а також налаштувати повторення, якщо зустріч регулярна.",
    faq_sessions_q2: "Як завантажити запис сесії?",
    faq_sessions_a2: "Після створення сесії натисніть кнопку «Завантажити» праворуч від назви. Підтримуються відео- та аудіофайли.",
    faq_sessions_q3: "Скільки часу займає аналіз запису?",
    faq_sessions_a3: "Зазвичай аналіз займає від кількох хвилин до години, залежно від довжини запису. Ви зможете переглянути аналіз одразу після обробки.",

    faq_analysis_title: "Аналіз і конфіденційність",
    faq_analysis_q1: "Хто може бачити мої записи та аналіз?",
    faq_analysis_a1: "Доступ до цієї інформації є тільки у вас та адміністрації.",
    faq_analysis_q2: "Чи можна скачати запис сесії потім?",
    faq_analysis_a2: "Так! Ви можете зберегти запис пізніше, якщо знадобиться.",

    faq_support_title: "Технічна підтримка",
    faq_support_q1: "Що робити, якщо у мене виникло питання?",
    faq_support_a1: "Ви завжди можете звернутися до нашої служби підтримки через чат або по email. Ми відповімо вам протягом робочого дня. Також ви можете зв'язатися зі своїм куратором з будь-якого питання.",
    faq_support_q2: "Що робити, якщо не завантажується відео або виникають помилки?",
    faq_support_a2: "Перевірте стабільність інтернет-з'єднання. Якщо проблема повторюється, напишіть у підтримку — ми допоможемо!",
    faq_support_q3: "Як швидко відправити повідомлення про помилку або пропозицію?",
    faq_support_a3: "Використовуйте гарячу клавішу Ctrl+/ для швидкого надсилання повідомлення про помилку або пропозицію. Це найзручніший спосіб зв'язатися з технічною підтримкою.",
    sideMenu_settings: "Налаштування",
    sideMenu_help: "Допомога",
    sideMenu_administrator: "Адміністрація",
    sideMenu_logout: "Вихід",

    sideMenuSettings_fontSize: "Розмір шрифту",
    sideMenuSettings_timezone: "Часовий пояс",
    sideMenuSettings_timezoneAuto: "(автоматично)",

    // Timezone names (UTC-12 to UTC+14)
    timezone_gmt_minus_12: "GMT-12",
    timezone_pago_pago: "Паго-Паго",
    timezone_honolulu: "Гонолулу",
    timezone_anchorage: "Анкоридж",
    timezone_los_angeles: "Лос-Анджелес",
    timezone_denver: "Денвер",
    timezone_chicago: "Чикаго",
    timezone_new_york: "Нью-Йорк",
    timezone_caracas: "Каракас",
    timezone_sao_paulo: "Сан-Паулу",
    timezone_noronha: "Норонья",
    timezone_azores: "Азори",
    timezone_london: "Лондон",
    timezone_paris: "Париж",
    timezone_kiev: "Київ",
    timezone_moscow: "Москва",
    timezone_dubai: "Дубай",
    timezone_karachi: "Карачі",
    timezone_dhaka: "Дакка",
    timezone_bangkok: "Бангкок",
    timezone_shanghai: "Шанхай",
    timezone_tokyo: "Токіо",
    timezone_sydney: "Сідней",
    timezone_noumea: "Нумеа",
    timezone_auckland: "Окленд",
    timezone_tongatapu: "Нукуалофа",
    timezone_kiritimati: "Кіритіматі",

    sideMenuPrivacy_updatePassword: "Змінити пароль",
    sideMenuPrivacy_oldPassword: "Поточний пароль",
    sideMenuPrivacy_newPassword: "Новий пароль",
    sideMenuPrivacy_changePassword: "Змінити пароль",

    bottomMenu_Sessions: 'Сесії',
    bottomMenu_Notes: "Нотатки",
    bottomMenu_Chat: 'Чат',
    bottomMenu_Calendar: 'Календар',
    bottomMenu_Lifeline: 'Лінія життя',
    bottomMenu_Analysis: 'Аналіз',
    bottomMenu_Statistic: 'Статистика',
    bottomMenu_Mindmap: 'Майндмап',
    mindmap_new_board: 'Нова дошка',
    mindmap_delete: 'Видалити',
    mindmap_delete_confirm: 'Видалити цю дошку?',
    mindmap_basic: 'Фігури',
    mindmap_box: 'блок',
    mindmap_round: 'коло',
    mindmap_triangle: 'трикутник',
    mindmap_trapezoid: 'трапеція',
    mindmap_star: 'зірка',
    mindmap_sticker: 'стікер',
    mindmap_delete_block: 'Видалити',
    mindmap_delete_cancel: 'Скасувати',
    mindmap_export: 'Експорт JSON',
    mindmap_context_export: 'Експорт',
    mindmap_context_delete: 'Видалити',
    mindmap_arrows: 'Стрілки',
    mindmap_arrow_thin: 'Тонка стрілка',
    mindmap_arrow_thick: 'Товста стрілка',
    mindmap_arrow_hollow: 'Порожня стрілка',
    mindmap_arrows_manual: 'Ручні',
    mindmap_arrow_manual_thin: 'Ручна тонка',
    mindmap_arrow_manual_thick: 'Ручна товста',
    mindmap_arrow_manual_hollow: 'Ручна порожня',
    mindmap_arrows_auto: 'Авто',
    mindmap_arrows_straight: 'Прямі',
    mindmap_arrow_straight_thin: 'Пряма тонка',
    mindmap_arrow_straight_thick: 'Пряма товста',
    mindmap_arrow_straight_hollow: 'Пряма порожня',
    mindmap_arrows_block: 'З текстом',
    mindmap_arrow_block: 'Блочна стрілка з текстом',
    mindmap_arrow_hint: 'Оберіть тип стрілки, потім натисніть на дві оранжеві точки для з\'єднання фігур',
    mindmap_manual_hint_line1: 'Сегмент: перетягнути (Shift=вільно) | Точка: перетягнути (Shift=вирівняти)',
    mindmap_manual_hint_line2: 'Подвійний клік: додати точку | ПКМ: видалити',
    mindmap_center_camera: 'Центрувати все',
    mindmap_undo: 'Скасувати (Ctrl+Z)',
    mindmap_reset_zoom: 'Скинути масштаб',
    mindmap_fullscreen: 'Повний екран',
    mindmap_exit_fullscreen: 'Вийти з повного екрана',
    mindmap_other: 'Інше',
    mindmap_text: 'Текст',
    mindmap_text_placeholder: 'Введіть текст...',
    mindmap_media: 'Медіа',
    mindmap_add_media: 'Додати медіа',
    mindmap_media_url: 'Посилання',
    mindmap_media_url_placeholder: 'https://example.com/image.jpg',
    mindmap_upload_file: 'Завантажити файл',
    mindmap_or: 'або',
    mindmap_add: 'Додати',
    mindmap_folders: 'Папки',
    mindmap_folders_filter_client: 'Тільки папки клієнта',
    mindmap_folders_empty: 'Папки не знайдено',
    mindmap_folders_no_subfolders: 'Немає підпапок',
    mindmap_folders_open: 'Відкрити папку',
    mindmap_notes: 'Нотатки',
    mindmap_notes_empty: 'Нотатки не знайдено',
    mindmap_untitled_note: 'Без назви',
    mindmap_tasks: 'Завдання',
    mindmap_tasks_filter_client: 'Тільки завдання клієнта',
    mindmap_tasks_empty: 'Завдання не знайдено',
    mindmap_untitled_task: 'Без назви',
    mindmap_draw: 'Малювати',
    mindmap_draw_color: 'Колір',
    mindmap_draw_width: 'Товщина',
    mindmap_settings: 'Налаштування',
    mindmap_background_color: 'Фон',
    mindmap_background_type_color: 'Колір',
    mindmap_background_type_cork: 'Дошка',
    mindmap_show_dots: 'Показати точки',
    mindmap_fill: 'Заливка',
    mindmap_text_color: 'Колір тексту',
    mindmap_border: 'Межа',
    mindmap_show_all: 'Показати все',
    mindmap_show_client_only: 'Тільки для клієнта',
    back: 'Назад',
    bottomMenu_lifeline: 'Лінія життя',

    'dashboard_page_title': 'Панель управління',

    // Notes Widget
    'notes_widget_title': 'Нотатки',
    'notes_widget_view_all': 'Переглянути всі нотатки',
    'notes_widget_no_notes': 'Нотаток поки немає',
    'notes_widget_create_first': 'Створити першу нотатку',

    login_Appname: appName.toUpperCase(),
    login_LoginText: "Увійти в "+appName,
    login_AllRightsText: "Усі права захищені. "+appName,
    login_email: "Email адреса",
    login_password: "Пароль",
    login_remember_me: "Запам'ятати мене",
    login_forgot_password: "Забули пароль?",
    login_proceed: "Продовжити",
    login_sign_up: "Реєстрація",
    
    signup_title: "Створити акаунт",
    signup_name: "Ім'я",
    signup_email: "Email адреса",
    signup_password: "Пароль",
    signup_repeat_password: "Повторіть пароль",
    signup_remember_me: "Запам'ятати мене",
    signup_proceed: "Продовжити",
    signup_or: "або",
    signup_google: "Увійти через Google",
    signup_login: "Вхід",
    
    analysis_file_name: "Ім'я файлу:",
    analysis_content: "Зміст аналізу:",
    analysis_file_placeholder: "Введіть ім'я файлу (наприклад, 'нотатки-сесії')",
    analysis_content_placeholder: "Введіть текст аналізу тут...",
    analysis_create_file: "Створити новий файл",
    analysis_append_to: "Додати до",
    analysis_error_empty: "Будь ласка, введіть ім'я файлу та зміст аналізу",
    analysis_error_content: "Будь ласка, введіть зміст аналізу для додавання",
    
    common_back: "Назад",
    common_user_avatar: "Аватар користувача",
    common_report_screenshot: "Скріншот звіту",
    common_error_prefix: "Помилка: ",

    gDrive: gDrive,
    desktop_uploadFile: 'Завантажити файл',
    desktop_uploadGDrive: `Додати\u00A0файл\u00A0з\u00A0${gDrive}`,
    desktop_resetPositions: `Скинути\u00A0позиції`,
    desktop_deleteFromGDrive: `Видалити\u00A0з\u00A0${gDrive}`,
    desktop_deleteSelectedFiles: (count: string | number)=>`Видалити\u00A0виділені\u00A0${count}\u00A0файлів`,
    desktop_delete: (name: string)=>`Видалити\u00A0${name}`,
    desktop_addAnalysis: "Додати аналіз",
    desktop_createFolder: "Створити папку",
    desktop_rename: "Перейменувати",
    desktop_moveFilesUp: "Перемістити файли вгору",
    desktop_options: "Параметри...",

    'Client': 'Клієнт',
    'All clients': 'Всі клієнти',
    'account_disabled': 'Акаунт деактивовано',

    allTime: 'За весь час',
    lastYear: 'За останній рік',
    lastMonth: 'За останній місяць',
    lastWeek: 'За останній тиждень',

    hotkeys_title: 'Гарячі клавіші',
    hotkeys_general: 'Загальні',
    hotkeys_navigation: 'Навігація',
    hotkeys_show_window: 'Показати це вікно',
    hotkeys_close_modal: 'Закрити модальне вікно',
    hotkeys_save: 'Зберегти',
    hotkeys_undo: 'Скасувати',
    hotkeys_message_placeholder: 'Введіть ваше повідомлення...',
    hotkeys_send_report: 'Відправити звіт',
    report_title: 'Звіт',
    'report.screenshot': 'Скріншот',
    'report.logs': 'Логи',
    'report.no_logs': 'Логи недоступні',
    'report.deleted': 'Звіт видалено',
    'report.delete_error': 'Сталася помилка',

    age_years_1: 'рік',
    age_years_2_4: 'роки',
    age_years_5_plus: 'років',
    'events_without_dates': 'Події без дат',
    'events': 'Події',
    'lifeline_title': 'Лінія життя',
    'lifeline_add_event': 'Додати подію',
    'lifeline_loading': 'Завантаження подій...',
    'lifeline_go_to_session': 'Перейти до сесії',
    'lifeline_no_events': 'Події не знайдено',
    'error_prefix': 'Помилка:',
    'lifeline_create_error': 'Помилка при створенні події',
    'lifeline_event_type': 'Тип події',
    'lifeline_positive_event': 'Позитивна подія',
    'lifeline_negative_event': 'Негативна подія',
    'lifeline_important_event': 'Важлива подія',
    'lifeline_importance_level': 'Рівень важливості',
    'lifeline_event_title': 'Подія',
    'lifeline_event_description': 'Опис',
    'lifeline_event_date': 'Дата події',
    'lifeline_save_event': 'Зберегти подію',
    'lifeline_cancel': 'Скасувати',
    'lifeline_edit_event': 'Редагувати подію',
    'lifeline_delete_event': 'Видалити подію',
    'lifeline_save_changes': 'Зберегти зміни',
    'lifeline_loading_save': 'Збереження...',
    'lifeline_error_save': 'Помилка при збереженні',
    'lifeline_success_save': 'Подію збережено',
    'lifeline_error_load': 'Помилка при завантаженні подій',
    'lifeline_error_delete': 'Помилка при видаленні події',
    'lifeline_confirm_delete': 'Ви впевнені, що хочете видалити цю подію?',
    'client_confirm_delete': 'Ви впевнені, що хочете видалити цього клієнта?',
    'lifeline_from_session_date': 'Із сесії [date]',
    'common_loading': 'Завантаження...',
    'common_error': 'Помилка',
    'common_success': 'Успішно',
    'common_cancel': 'Скасувати',
    'common_edit': 'Редагувати',
    'common_yes': 'Так',
    'common_no': 'Ні',
    'common_show_more': 'Показати більше',
    'common_show_less': 'Приховати',
    'lifeline_show_all_events': 'Показати всі події',
    'lifeline_hide_unimportant': 'Приховати неважливі події',
    'meeting_back': 'Повернутися',
    'no_client_selected': 'Клієнт не вибраний',
    'select_note_edit': 'Виберіть нотатку для редагування або додайте нову',
    'full_analysis_one_list': 'Один список',
    'full_analysis_one_list_desc': 'Показати всі записи вибраного клієнта як один файл аналізу',
    'full_analysis_all_files': 'Всі клієнти',
    'full_analysis_all_files_desc': 'Показати файли всіх клієнтів',
    'clients_switch_clients': 'Клієнти',
    'clients_switch_schedule': 'Розклад',
    'search_clients_placeholder': 'Клієнти',
    'sideMenu_desktop': 'Робочий стіл',
    'sideMenu_startScreen': 'Стартовий екран',
    'day_sun': 'Нд.',
    'day_mon': 'Пн.',
    'day_tue': 'Вт.',
    'day_wed': 'Ср.',
    'day_thu': 'Чт.',
    'day_fri': 'Пт.',
    'day_sat': 'Сб.',
    'day_sunday': 'Неділя',
    'day_monday': 'Понеділок',
    'day_tuesday': 'Вівторок',
    'day_wednesday': 'Середа',
    'day_thursday': 'Четвер',
    'day_friday': 'П\'ятниця',
    'day_saturday': 'Субота',
    'loading': 'Завантаження...',
    'calendar_day': 'День',
    'calendar_week': 'Тиждень',
    'calendar_month': 'Місяць',
    'calendar_year': 'Рік',
    'calendar_today': 'Сьогодні',
    'month_january': 'Січень',
    'month_february': 'Лютий',
    'month_march': 'Березень',
    'month_april': 'Квітень',
    'month_may': 'Травень',
    'month_june': 'Червень',
    'month_july': 'Липень',
    'month_august': 'Серпень',
    'month_september': 'Вересень',
    'month_october': 'Жовтень',
    'month_november': 'Листопад',
    'month_december': 'Грудень',
    'month_jan': 'Січ',
    'month_feb': 'Лют',
    'month_mar': 'Бер',
    'month_apr': 'Кві',
    'month_may_short': 'Тра',
    'month_jun': 'Чер',
    'month_jul': 'Лип',
    'month_aug': 'Сер',
    'month_sep': 'Вер',
    'month_oct': 'Жов',
    'month_nov': 'Лис',
    'month_dec': 'Гру',
    'schedule_no_sessions_found': 'Сесії не знайдено',
    'schedule_no_sessions_match_search': 'Жодна сесія не відповідає вашому пошуку',
    'session_upload': 'Завантажити',
    'session_wait': 'Зачекайте...',
    'session_watch': 'Дивитися',
    'session_error': 'Помилка',
    'session_status_upcoming': 'Заплановано',
    'session_status_finished': 'Завершено',
    'session_status_cancelled': 'Скасовано',
    'session_processing': 'Обробка...',
    'session_with': 'Сесія з',
    'view_profile': 'Переглянути профіль',
    'transcription_of_session': 'Розшифровка сесії',
    'minimize': 'Згорнути',
    'most_used_words': 'Найбільш використовувані слова',
    'session_statistics': 'статистика сесії',
    'most_common_word': 'Найчастіше використовуване слово',
    'used': 'використано',
    'times': 'разів',
    'during_all_sessions': 'за всі сесії',
    'used_word_today_first_time': 'використав це слово сьогодні вперше',
    'word_appeared_in_speech': 'слово "[word]" з\'явилося в мові клієнта під час [session] сесії',
    'word_appeared_in_sessions': '"[word]" зустрічається в [count] сесіях',
    'highlights_previous_session': 'Основні моменти попередньої сесії',
    'recommendations_upcoming_session': 'Рекомендації до майбутньої сесії:',
    'add_task': 'Додати завдання',
    'plan_new_session': 'Запланувати нову сесію',
    'open_previous_statistic': 'Відкрити попередню статистику',
    'fear_public_speaking': 'Страх майбутнього публічного виступу',
    'doubts_attractiveness': 'Сумніви щодо своєї привабливості',
    'panic_attacks': 'Панічні атаки',
    'breathing_exercises': 'Дихальні вправи',
    'appointment_psychiatrist': 'Записатися на прийом до психіатра',
    'calming_scheme': 'Схема заспокоєння перед публічним виступом',
    'meetingPage_todays_speed': 'Швидкість сьогодні',
    'meetingPage_session_statistics': 'статистика сесії',
    'meetingPage_graphicSpeed_title': 'Гучна мова',
    'meetingPage_graphicSpeed_text': '[name] говорив(ла) на [percent]% голосніше звичайного сьогодні',
    'meetingPage_taciturnity_title': 'Мовчазність',
    'meetingPage_taciturnity_text': '[name] мовчав(ла) [percent]% часу сесії сьогодні',
    'meetingPage_graphicSpeed_bottom_a': 'середня швидкість',
    'meetingPage_graphicSpeed_bottom_b': 'слів за хвилину',
    'meetingPage_todays_average_speed': 'Середня швидкість сьогодні',
    'meetingPage_words_per_minute': 'слів за хвилину',
    'meetingPage_volume_title': 'Аналіз гучності',
    'meetingPage_volume_subtitle': 'Рівні гучності сесій у часі',
    'meetingPage_volume_average': 'Середня гучність',
    'meetingPage_average_speed_title': 'Середня швидкість',
    'meetingPage_average_speed_subtitle': 'Швидкість мови по сесіях',
    'meetingPage_average_speed_bottom': 'слів за хвилину',
    'common_at': 'о',
    'task_assigned_to_session': 'Прив\'язано до сесії',
    'session_no_description': 'Немає опису для цієї сесії',
    'debug_analyze_session': 'Аналізувати сесію',
    'debug_watch_video': 'Дивитися відео',
    'debug_add_task': 'Додати завдання',
    'debug_chat': 'Чат',

    // Session creation
    'session_new_session': 'Нова сесія',
    'session_edit_session': 'Редагувати сесію',
    'session_add_title': 'Додати заголовок',
    'session_select_date': 'Виберіть дату сесії',
    'session_start_time': 'Час початку',
    'session_end_time': 'Час закінчення',
    'session_add_task': 'Додати завдання',
    'session_add_description': 'Додати опис або вкладення',
    'session_save_draft': 'Зберегти чернетку',
    'session_delete': 'Видалити',
    'session_save': 'Зберегти',
    'session_create': 'Створити',

    // Repeat options
    'repeat_every': 'Повторювати кожні: ',
    'repeat_interval': 'Інтервал повторення: ',
    'repeat_dont_repeat': 'Не повторювати',
    'repeat_everyday': 'щодня',
    'repeat_every_other_day': 'через день',
    'repeat_every_week': 'щотижня',
    'repeat_every_two_weeks': 'кожні два тижні',
    'repeat_every_month': 'щомісяця',
    'repeat_custom': 'налаштувати',
    'repeat_number_of_sessions': 'Кількість сесій: ',
    'repeat_number_of_events': 'Кількість подій: ',
    'repeat_sessions_label': 'повторити: ',

    // Calendar event form
    'calendar_event_start_time': 'час початку',
    'calendar_event_end_time': 'час закінчення',
    'calendar_event_text': 'текст події',
    'calendar_event_delete_all': 'Видалити всі',
    'calendar_event_save_all': 'Оновити це та наступні',
    'calendar_event_event': 'Подія',
    'calendar_event_task': 'Завдання',
    'calendar_event_session': 'Сесія',
    'calendar_new_event': 'Нова подія',
    'calendar_new_task': 'Нове завдання',
    'calendar_new_session': 'Нова сесія',
    'calendar_edit_event': 'Редагувати подію',
    'calendar_edit_task': 'Редагувати завдання',
    'calendar_edit_session': 'Редагувати сесію',

    // Validation messages
    'validation_enter_date': 'Введіть дату',
    'validation_enter_start_time': 'Введіть час початку',
    'validation_enter_end_time': 'Введіть час закінчення',

    // Analysis folder management
    'analysis_create_new_folder': 'Створити нову папку',
    'analysis_add_file': 'Додати файл',

    // Load more functionality
    'load_more': 'Завантажити ще',
    'no_more_sessions': 'Більше сесій для завантаження немає',

    // Subtitles context menu
    'subtitles_context_edit': 'Редагувати',
    'subtitles_context_comment': 'Коментар',
    'subtitles_context_send_to': 'Відправити до...',
    'subtitles_context_folder': 'Папки',
    'subtitles_context_desktop': 'Робочий стіл',
    'subtitles_context_add_tag': 'Додати тег',
    'subtitles_context_assign': 'Призначити...',
    'subtitles_context_red_flag': 'Червоний прапор',
    'subtitles_context_attention': 'Увага',
    'subtitles_context_edit_fast_actions': 'Змінити швидкі дії',

    // Comment popup
    'subtitles_comment_add': 'Додати коментар',
    'subtitles_comment_close': 'Закрити',
    'subtitles_comment_done': 'Готово',

    // Send to desktop functionality
    'subtitles_select_text_to_send': 'Будь ласка, виберіть текст для відправки на робочий стіл',
    'subtitles_no_text_selected': 'Текст не вибрано',
    'subtitles_quote_from_meeting': 'Цитата зі зустрічі',
    'subtitles_meeting_quote_tag': 'Цитата зустрічі',
    'subtitles_selected_text_title': 'Вибраний текст зі зустрічі',
    'subtitles_text_saved_success': 'Текст успішно збережено на робочий стіл!',
    'subtitles_save_failed': 'Не вдалося зберегти текст на робочий стіл. Спробуйте ще раз.',

    // Send to folder functionality
    'send_folder_client_tag': 'Клієнт',
    'send_folder_quote_title': 'Цитата із сесії: ',
    'send_folder_preview': 'Попередній перегляд',
    'send_folder_action_text': 'Нотатка, яку ви додали з',
    'send_folder_session_suffix': 'сесії',
    'send_folder_send_to_selected': 'Відправити до вибраного файлу',
    'send_folder_create_and_send': 'Створити файл і відправити',
    'send_folder_default_filename': 'файл.аналіз',

    // Meeting page error messages
    'meeting_auth_error': 'Виникла помилка автентифікації',
    'meeting_invalid_response': 'Невірний формат відповіді від сервера',
    'meeting_processing_error': 'Помилка обробки відповіді сервера',
    'meeting_network_error': 'Виникла мережева помилка при видаленні слова',
    'meeting_default_name': 'Вони',

    // Tasks
    'tasks_title': 'Задачі',
    'tasks_add': 'Додати задачу',
    'tasks_add_new': 'Додати нову задачу',
    'tasks_new_task': 'Нова задача',
    'tasks_edit': 'Редагувати задачу',
    'tasks_all_tags': 'Всі мітки',
    'tasks_empty': 'Немає задач. Натисніть "Додати задачу" щоб створити.',
    'tasks_load_error': 'Не вдалося завантажити задачі',
    'tasks_save_error': 'Не вдалося зберегти задачу',
    'tasks_delete_error': 'Не вдалося видалити задачу',
    'tasks_confirm_delete': 'Видалити цю задачу?',
    'tasks_title_required': 'Будь ласка, введіть назву задачі',
    'tasks_field_title': 'Назва',
    'tasks_field_datetime': 'Дата і час',
    'tasks_field_tags': 'Мітки',
    'tasks_has_date': 'Запланувати на певну дату/час',
    'tasks_title_placeholder': 'Введіть назву задачі...',
    'tasks_tag_placeholder': 'Додати мітку...',
    'tasks_field_description': 'Опис',
    'tasks_description_placeholder': 'Додайте деталі про задачу...',
    'tasks_datetime_label': 'Дата і час',
    'tasks_assign_to_session': 'Призначити на сесію',
    'tasks_session_none': 'Немає',
    'tasks_session_untitled': 'Сесія без назви',
    'tasks_no_future_sessions': 'Немає майбутніх сесій',
    
    // Analysis
    'analysis_title': 'Аналіз',
    'analysis_add_folder': 'Додати нову папку',
    'analysis_new_folder': 'Нова папка',
    'analysis_confirm_delete': 'Видалити',
    'analysis_select_client': 'Виберіть клієнта для перегляду аналізу',
    'analysis_filter_client': 'Показати тільки файли цього клієнта',
    'analysis_empty_folder': 'Немає файлів або папок',

    // Нотатки
    'notes_title': 'Нотатки',
    'notes_add': 'Додати нотатку',
    'notes_add_new': 'Додати нову нотатку',
    'notes_new_title': 'Нова нотатка',
    'notes_remove': 'Видалити',
    'notes_save': 'Зберегти нотатку',
    'notes_empty': 'Нотаток поки немає. Натисніть "Додати нотатку" щоб створити.',
    'notes_select_or_create': 'Виберіть нотатку або створіть нову',
    'notes_confirm_delete': 'Видалити цю нотатку?',
    'notes_load_error': 'Не вдалося завантажити нотатки',
    'notes_save_error': 'Не вдалося зберегти нотатку',
    'notes_delete_error': 'Не вдалося видалити нотатку',
    'notes_deleted_success': 'Нотатку успішно видалено',
    'notes_bound_to_client': 'Прив\'язати до клієнта',
    'tasks_bound_to_client': 'Прив\'язати до клієнта',

    // Filter tooltips
    'filter_show_all_notes': 'Показати всі нотатки',
    'filter_show_client_notes': 'Показати тільки нотатки клієнта {name}',
    'filter_show_all_tasks': 'Показати всі задачі',
    'filter_show_client_tasks': 'Показати тільки задачі клієнта {name}',
    'filter_show_all_files': 'Показати всі файли',
    'filter_show_client_files': 'Показати тільки файли клієнта {name}',

    // Goals
    'goals_title': 'Цілі',
    'goals_add': 'Додати ціль',
    'goals_edit': 'Редагувати ціль',
    'goals_empty': 'Немає цілей. Натисніть "Додати ціль" щоб створити.',
    'goals_select_client': 'Виберіть клієнта для перегляду цілей',
    'goals_field_emoji': 'Емодзі',
    'goals_field_title': 'Назва цілі',
    'goals_field_start_date': 'Дата початку',
    'goals_select_emoji': 'Виберіть емодзі',
    'goals_title_placeholder': 'наприклад, дні без куріння',
    'goals_title_required': 'Будь ласка, введіть назву цілі',
    'goals_confirm_delete': 'Видалити цю ціль?',
    'goals_confirm_reset': 'Скинути цю ціль до дня 0?',
    'goals_reset': 'Скинути до дня 0',
    'goals_delete': 'Видалити ціль',
    'goals_click_to_edit_days': 'Натисніть щоб змінити дні',
    'goals_load_error': 'Не вдалося завантажити цілі',
    'goals_save_error': 'Не вдалося зберегти ціль',
    'goals_delete_error': 'Не вдалося видалити ціль',
    'goals_reset_error': 'Не вдалося скинути ціль',
    'goals_update_error': 'Не вдалося оновити ціль',
    'goals_add_new': 'Додати нову ціль',

    // Bottom menu
    'bottomMenu_Tasks': 'Задачі',

    // Statistics page
    'statistic_title': 'Статистика',
    'statistic_select_client': 'Виберіть клієнта для перегляду статистики',
    'statistic_all_time': 'Весь час',
    'statistic_month': 'Місяць',
    'statistic_week': 'Тиждень',
    'statistic_custom': 'Свій діапазон',
    'statistic_most_used_words': 'Найбільш вживані слова',
    'statistic_no_data': 'Немає даних',
    'statistic_average_speed': 'Середня швидкість мови',
    'statistic_speed_subtitle': 'По всіх сесіях',
    'statistic_avg_speed_label': 'Середня швидкість',
    'statistic_volume': 'Гучність мови',
    'statistic_volume_subtitle': 'Рівень гучності по сесіях',
    'statistic_avg_volume': 'Середня гучність',
    'statistic_silence': 'Мовчазність',
    'statistic_silence_label': 'Середній відсоток мовчання',
    'statistic_session': 'Сесія',

    'connection_lost': 'З\'єднання втрачено',
    'connection_lost_message': 'Виникли проблеми з підключенням до сервера. Перевірте інтернет-з\'єднання.',
    'connection_retry_in': 'Повторна спроба через',
    'connection_retrying': 'Підключення...',
    'connection_retry_now': 'Спробувати зараз',
};